import React from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Paper, Select, Typography, useTheme } from '@mui/material';
import uuid from 'react-uuid';
import { styled } from '@mui/system';

import { PersonalDetailsValues } from '../PersonalDetailsStep';
import { CustomPersonalDetailData, LabelData } from '../../../../../../api';
import { useLanguage } from '../../../../../../common/GeneralUtils';

type RenderDropDownDetailProps = {
  customPersonalDetail: CustomPersonalDetailData;
  setFieldValue: (field: string, value: any) => void;
  values: PersonalDetailsValues;
};

export const FormStyledPaper = styled(Paper)`
  && {
    background-color: ${(props: any) =>
      props.backgroundColor || props.theme.palette.mb.ground}; // dynamic background color
  }
`;

export const FormStyledMenuItem = styled(MenuItem)(
  ({ textColor, backgroundColor }: { textColor?: string; backgroundColor: string }) => ({
    color: textColor,
    background: backgroundColor,
    backgroundColor,
    '&:hover': {
      filter: 'brightness(150%)',
    },
  }),
);

export const RenderDropDownDetail = ({ customPersonalDetail, setFieldValue, values }: RenderDropDownDetailProps) => {
  const language = useLanguage();
  const theme = useTheme();
  const textColor = theme.customTheme.palette.text.primary;
  const { background } = theme.customTheme.palette;

  // @ts-ignore
  const value = values.custom_personal_details?.[customPersonalDetail.id];
  const detailId = customPersonalDetail.id;
  const id = `RenderDropDownDetail-${uuid()}`;
  return (
    <Grid container flexDirection="column" item>
      <FormControl fullWidth>
        <InputLabel id={id}>{customPersonalDetail.label[language]}</InputLabel>
        <Select
          labelId={id}
          label={customPersonalDetail.label[language]}
          id={id}
          value={value}
          onChange={(e) => setFieldValue(`custom_personal_details.${detailId}`, e.target.value)}
          renderValue={(v: any) => <Typography>{v}</Typography>}>
          {customPersonalDetail.drop_down_options?.map((item: LabelData) => (
            <FormStyledMenuItem
              key={`MenuItem-${item[language]}`}
              value={item[language]}
              textColor={textColor}
              backgroundColor={background}>
              {item[language]}
            </FormStyledMenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};
